class OrderReviewCta extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('#checkout-form');
    this.continueBtn = this.querySelector('#continue-shopping');
    this.submitButton = this.form.querySelector('button');

    this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this), { once: true });
  }

  async connectedCallback() {
    const totalNumberOfMeals = Number(document.querySelector('.review-order').dataset.totalNumberOfMeals);
    const totalSelectedMealsCount = window.bundleHelpers.totalSelectedMealsCount();
    const orderIsComplete = totalSelectedMealsCount === totalNumberOfMeals && totalNumberOfMeals > 0 && (await bundleHelpers.validateBundleRules());
    this.form.classList.toggle('hidden', !orderIsComplete);
    this.continueBtn.classList.toggle('hidden', orderIsComplete);
  }

  async onSubmitHandler(event) {
    event.preventDefault();
    this.submitButton.setAttribute('disabled', 'disabled');
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const cart = await window.bundleHelpers.onCartSubmit(event);
    if (cart.items && cart.items.length > 0) {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.setAttribute('name', 'checkout');
      console.log('submitting form', this.form);
      this.submitButton.click();
    } else {
      this.submitButton.classList.remove('loading');
      this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      this.submitButton.removeAttribute('disabled');
    }
  }
}

customElements.define('order-review-cta', OrderReviewCta);
